
//shows and controls the top-right GPS status pane

import * as L from 'leaflet';
import {copyToClipboard} from "@/engine/helpers/clipboard.js";
import {UITemplates} from "@/engine/UITemplates.js";
import {UIPHideable} from "@/engine/UIcomponents/UIPHideable.js";

export const UIStatusPane = L.Control.extend({

    includes: [UIPHideable],

    //geoObject - the main geoObject
    //required options:
    //  requiredAccuracy
    //  UIDialogFactory
    //  actionListeners

    initialize: function(options) {
        this.options = options?options:{};

        if (this.options.position === undefined) {
            this.options.position = "topright";
        }
        this.options.interactive = true;
        this.location = null;

        this.requiredAccuracy = options.requiredAccuracy;
        this.UIDialogFactory = options.UIDialogFactory;

        let headerRecord = {
            node: null,
            empty: true,
            updateHandler: null,
            initialize: null,
            createdAt: null
        };

        this.headers = {
            gpsHeader: {
                __proto__: headerRecord,
                updateHandler: this.gpsHeaderUpdate.bind(this),
                initialize: this.gpsHeaderInit.bind(this),
            },
            workspaceHeader: {
                __proto__: headerRecord,
            }
        }
    },

    onAdd: function(map) {
        this._div = L.DomUtil.create('div', 'pane statusPane');
        this._div.innerHTML = UITemplates.getContent("statusPane")
        L.DomEvent.disableClickPropagation(this._div);

        // panel is hidden by default
        this._div.hidden = true;
        for (let el of Object.keys(this.headers)) {
            this.headers[el].node = this._div.querySelector('.' + el)
            if (typeof this.headers[el].initialize === "function") {
                this.headers[el].initialize(this.headers[el].node)
            }
        }
        return this._div;
    },

    update: function (header, data) {
        let h = this.headers[header]
        if (!h)
            return

        let empty = h.empty
        h.empty = ! h.updateHandler(h.node, data)

        if (h.empty != empty && empty == false) {
            h.createdAt = new Date().getTime()
        }
        // hide / show the pane
        if ( !h.empty ) {
            if (!this.isVisible())
                this.show()
            return
        } else {
            let allEmpty = true
            for (let el of Object.keys(this.headers) ) {
                if (! this.headers[el].empty) {
                    allEmpty = false
                    break
                }
            }
            if (allEmpty && this.isVisible())
                this.hide()
        }
    },

    gpsHeaderInit: function (_div) {
        //define click listeners for header
        _div.addEventListener("click", function (ev) {
            if (ev.target.tagName === "A" && ev.target.getAttribute("target") === "gpsErrorWindow") {
                this._createGPSErrorNoticeDialog();
                return
            }
            if (ev.target.tagName === "A" && ev.target.getAttribute("target") === "gpsLowAccuracyWindow") {
                this._createGPSLowAccuracyNoticeDialog();
                return
            }

            if (! _div.querySelector("#gpsPaneCoordinates").hidden) {
                let text = this.location.latitude + ', ' + this.location.longitude;
                copyToClipboard(text, "YOUR COORDINATES");
            }
        }.bind(this));
    },
    /*
    locationData.latitude
    locationData.longitude
    locationData.accuracy
    locationData.error
 */
    gpsHeaderUpdate: function (_div, location) {
        let selector = null;
        if (! location) {
            if (!_div)
                return false
            _div.childNodes.forEach( function (el) {el.hidden = true;});
            return false;
        }

        //GPS error
        if (location && location.error) {
            selector = "#gpsPaneError";
            this._bindValuesToDOM(_div, {error: location.error.message});
            //an initial startup state
        } else if (location && ! location.longitude) {
            selector = "#gpsPaneNotice";
            this._bindValuesToDOM(_div, {notice: 'DETERMINING LOCATION'});
            _div.querySelector("a[target=\"gpsLowAccuracyWindow\"]").hidden = true;
        } else {
            //selector = "#gpsPaneCoordinates";
            let notice = "";
            if (location.lowAccuracy) {
                notice = 'GPS ACCURACY TOO LOW';
                selector += ",#gpsPaneNotice";
                _div.querySelector("a[target=\"gpsLowAccuracyWindow\"]").hidden = false;
            } else {
                _div.querySelector("a[target=\"gpsLowAccuracyWindow\"]").hidden = true;
            }

            //fix coordinates with longitude above 180 (leaflet allow this) but other software possible want to see it with range -180:180
            let l = this._antimeridianToCoordinatesFix( {latitude: location.latitude, longitude: location.longitude} )
            this._bindValuesToDOM(_div, {
//                lat: l.latitude.toFixed(5),
//                lng: l.longitude.toFixed(5),
                notice: notice
            });
            this.location = l
        }
        _div.childNodes.forEach( function (el) {el.hidden = true;});
        _div.querySelectorAll(selector).forEach(function (el) {el.hidden = false;});
        return selector !== null
    },

    _createGPSLowAccuracyNoticeDialog: function(canPostpone) {
        this.UIDialogFactory.modalInfoWindow({
            title: "Your location accuracy is too low",
            content: UITemplates.getContent("gpsLowAccuracyWindow", {desktop: !UA.isMobileDevice}),
            closeButtonName: "Got it. Thanks!",
            postpone: canPostpone ? 45 : 0
        });
    },

    _createGPSErrorNoticeDialog: function(canPostpone) {
        this.UIDialogFactory.modalInfoWindow({
            title: "GPS isn't available on your device",
            content: UITemplates.getContent("gpsErrorWindow", {desktop: !UA.isMobileDevice}),
            closeButtonName: "Got it. Thanks!",
            postpone: canPostpone ? 45 : 0
        });
    },

    _bindValuesToDOM: function(root, options) {
        for (let item of Object.entries(options)) {
            root.querySelectorAll(`[data-bind="${item[0]}"]`).forEach( function (el) {
                el.innerHTML = item[1];
            })
        }
    },

    //for coordinates with longitude > 180 we do move them to the range -180:180
    _antimeridianToCoordinatesFix(location) {
        if (location.longitude > 180) {
            location.longitude -= 360;
        }
        return location
    }

});
